<template>
  <div class="feed-card feed__message-block">
    <div class="d-flex position-relative">
      <span class="v-line"></span>
      <span class="circle-step flex-shrink-0"></span>

      <div class="content">
        <h3 v-html="userActivity.title_html"></h3>
        <TimeInfos :userActivity="userActivity"/>

        <template v-if="driverInfos">
          <div class="driver-picture mb-3">
            <img v-if="driverInfos.avatar_url" :src="driverInfos.avatar_url" class="logo">
            <DriverDefaultPictureSvg v-else />
          </div>
          <div v-if="driverInfos.tow_truck_picture_url" class="mb-3 d-flex justify-content-center">
            <img
              :src="driverInfos.tow_truck_picture_url"
              :alt="$t('truck_en_route.tow_truck_image.alt')"
              class="img-fluid rounded tow-truck-image"
            />
          </div>
          <div class="mb-2 d-flex justify-content-center">
          <div v-if="hasPlate" class="license-plate d-flex align-items-center">
              <div v-if="isFrenchPlate" class="eu-band d-flex flex-column align-items-center justify-content-center px-2 h-100">
                  <div class="country-code">FR</div>
              </div>
              <div class="flex-grow-1 d-flex align-items-center justify-content-center">
                  <span class="plate-number">{{ formattedImmat }}</span>
              </div>
          </div>
          </div>
          <div>
            <template v-if="driverInfos.tow_truck_picture_url">
              {{ $t('truck_en_route.message_with_truck_image', { first_name: driverInfos.first_name }) }}
            </template>
            <template v-else>
              {{ $t('truck_en_route.message_without_truck_image', { first_name: driverInfos.first_name }) }}
            </template>
          </div>
       </template>
      </div>
    </div>
  </div>

</template>


<script>
  import TimeInfos from '@components/utils/TimeInfos.vue';
  import { isPresent, isValidFrenchPlate } from '@lib/utilities';

  export default {
    props: {
      userActivity: Object
    },
    components: {
      TimeInfos
    },
    computed: {
      driverInfos() {
        return this.userActivity.data.driver_infos
      },
      // Some companies append driver identifiers to the license plate
      // (e.g., GG489SZEEML). We extract only the standard French format when
      // it matches (2 letters + 3 digits + 2 letters, e.g., GG489SZ), and
      // otherwise fall back to the raw immat so non-SIV plates (e.g., "SR 1004")
      // are still displayed.
      formattedImmat() {
        if (!isPresent(this.driverInfos?.tow_truck_immat)) return '';
        const immat = String(this.driverInfos.tow_truck_immat).trim();
        // Match both new format (AA123BB) and old format (AA-123-BB)
        // Also extracts from longer strings with company suffixes (e.g., GG489SZEEML -> GG489SZ)
        const newFormatMatch = immat.match(/^[A-Z]{2}\d{3}[A-Z]{2}/);
        const oldFormatMatch = immat.match(/^[A-Z]{2}-\d{3}-[A-Z]{2}/);
        const match = newFormatMatch || oldFormatMatch;
        return match ? match[0] : immat;
      },
      hasPlate() {
        return isPresent(this.driverInfos?.tow_truck_immat);
      },
      // The blue "FR" EU band only belongs on modern SIV plates (post-2009).
      // Hide it for older FNI plates (e.g. "255 TY 52") that don't match the
      // SIV format. Tested against the formatted immat so company-suffixed
      // SIV plates (e.g. GG489SZEEML -> GG489SZ) still keep the band.
      isFrenchPlate() {
        return isValidFrenchPlate(this.formattedImmat);
      }
    }
  };
</script>

<style scoped>
.driver-picture {
  width: 60px;
  height: 60px;
  margin: 0 auto;
}

.driver-picture .logo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.tow-truck-image {
    max-height: 250px;
    object-fit: cover;
}

.license-plate {
    background: linear-gradient(180deg, #ffffff 0%, #f8f9fa 100%);
    border: 3px solid #000;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.3), inset 0 1px 3px rgba(255,255,255,0.8);
    font-family: 'Courier New', monospace;
    font-weight: bold;
    position: relative;
    overflow: hidden;
    width: 320px;
    height: 60px;
}

@media (max-width: 576px) {
    .license-plate {
        width: 280px;
        height: 50px;
    }
}

.license-plate::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(45deg, transparent 49%, rgba(255,255,255,0.1) 50%, transparent 51%);
    pointer-events: none;
}

.eu-band {
    background: #003087;
    color: white;
    text-orientation: mixed;
}

.country-code {
    font-size: 1.5rem;
    font-weight: bold;
}

.plate-number {
    font-size: 2.5rem;
    letter-spacing: 0.1em;
    color: #000;
    text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
}

@media (max-width: 576px) {
    .plate-number {
        font-size: 1.8rem;
    }
}
</style>